var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { TabsContainer, TabsContent, TabsContentWrapper, TabsList, TabsTrigger, } from "./subcomponents";
import { useRewardsPageContext } from "../../../context/rewardsPageContext";
import CertificateHistoryTab from "../CertificateHistoryTab";
import RewardsTab from "../RewardsTab";
var RewardsTabs = function (_a) {
    var activeTab = _a.activeTab, handleTabChange = _a.handleTabChange;
    var t = useTranslation().t;
    var _b = useRewardsPageContext(), hasCertificateHistory = _b.state.hasCertificateHistory, dispatch = _b.dispatch;
    var TabNames = [
        {
            name: t("fullDetailsPage.rewards"),
            value: "rewards",
            show: true,
            content: _jsx(RewardsTab, {}),
        },
        {
            name: t("fullDetailsPage.certificateHistory"),
            value: "certificate-history",
            show: hasCertificateHistory,
            content: _jsx(CertificateHistoryTab, {}),
        },
    ];
    return (_jsxs(TabsContentWrapper, __assign({ defaultValue: TabNames[0].value, value: activeTab, onValueChange: handleTabChange }, { children: [hasCertificateHistory && (_jsx(TabsContainer, { children: TabNames.map(function (tab) {
                    return tab.show && (_jsx(TabsList, __assign({ "aria-label": tab.name }, { children: _jsx(TabsTrigger, __assign({ value: tab.value, "data-type": "rewards", "data-reason": tab.name.toLocaleLowerCase(), "data-object": "button", "data-analytics": "clicktrackingevent", onMouseDown: function () {
                                return dispatch({ isActiveRewardsTab: tab.value === "rewards" });
                            } }, { children: tab.name.toUpperCase() })) }), "tabTrigger-".concat(tab.value)));
                }) })), TabNames.map(function (tab) { return (_jsx(TabsContent, __assign({ value: tab.value }, { children: tab.content }), "tabContent-".concat(tab.value))); })] })));
};
export default RewardsTabs;
